import { useDispatch } from 'react-redux';
import { userLogout } from 'store/action/user.action';

// import { Container } from './styles';

export default function Logout({ history }) {
  const dispatch = useDispatch();
  dispatch(userLogout());

  history.push('/');

  return null;
}
